import React from 'react';
import { PropagateResize } from 'app/components/resize-hooks';

import styles from './resizable-table.scss';

export const ResizableTable: React.FC<React.PropsWithChildren> = ({ children }) => {

  return <PropagateResize>
    <table className={styles.table}>
      {children}
    </table>
  </PropagateResize>;
};
